import React, { useEffect, useState } from 'react';
import { List, Divider, Button,Link, Grid, Box, Container } from '@mui/material';
import { ThemeClient } from '../contexts/Theme';
import Navbar from '../Navbar';
import Logo from '../components/Logo';

import CertificateButton from '../components/session/CertificateButton';
import Session from '../components/Sessions/SessionItem';
import ProgressBar from '../components/Sessions/ProgressBar';
import Navegation from '../components/Navegation'

import { useCompany } from '../contexts/Company';
import { useCode } from '../contexts/Code';
import { supabase } from '../supabaseClient';
import { useHistory } from 'react-router-dom';

import Gallery from '../components/Sessions/Gallery'

import MenuButtons from '../components/Sessions/MenuButtons'

import SessionItemSkeleton from '../components/Sessions/SessionItemSkeleton';

export default function Sessions() {
  const [sessions, setSessions] = useState([]);
  const { code } = useCode();
  const company = useCompany();

  const history = useHistory();
  const [label, setLabel] = useState('');

  const getSessions = async () => {
    const { data, error } = await supabase
      .from('sessions')
      .select('*')
      .eq('company', code)
      .order('date_from', { ascending: true });

    if (error) {
      return console.log(error);
    } else {
      console.log(data);
      setSessions(data);
    }
  };

  useEffect(() => {
    getSessions();
  }, []);

  React.useEffect(() => {
    if (company?.id == '45') {
      setLabel('Your Path');
    } else {
      setLabel('Tu ruta');
    }
  }, [company]);


  return (
    <ThemeClient>
      <Navbar title={label} />

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Logo
          style={{
            height: 'auto',
            maxWidth: '100%',
            marginTop: '2rem',
            marginBottom: '2rem',
          }}
        />

        <Gallery/>

        <List sx={{ width: '100%', bgcolor: 'background.paper' }}>
          {sessions.map((session, index) => (
            <Session
              key={session.id}
              session={session}
              onClick={(e) => history.push(`/sessions/${session.id}`)}
            />
          ))}

          {sessions.length === 0 && Array.from({ length: 15 }, (_, index) => (
            <SessionItemSkeleton key={index} />
          ))}

          <Divider light />
        </List>

        <ProgressBar sessions={sessions} />


        {/* <CertificateButton sessions={sessions} /> */}

      </Box>
      <Navegation/>
    </ThemeClient>
  );
}
